import { createFileRoute } from "@tanstack/react-router"

import { ChatPage } from "./-components/ChatPage"

export const Route = createFileRoute("/app/com/chat/")({
  component: ChatIndexPage,
})

function ChatIndexPage() {
  return <ChatPage renderLeftPanelOnSmallScreen />
}
